import classes from "@/components/Loading/Loading.module.css";
import { createBooleanDataset } from "@/utils/helpers";
import { FC } from "react";

const Loading: FC<LoadingProps> = (props) => {
  const { icon } = props;

  return <div {...createBooleanDataset({ icon })} className={classes.root} />;
};

type LoadingProps = {
  icon?: boolean;
};

export { Loading };
export type { LoadingProps };
